import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareBehindSquare4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSquareBehindSquare4"><Path fillRule="evenodd" clipRule="evenodd" d="M8 8V2H22V16H16V22H2V8H8ZM14.5 16H8V9.5H3.5V20.5H14.5V16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareBehindSquare4;
